import { Box, Heading } from "@chakra-ui/react";
import style from "./Privacypolicy.module.css"
import PrivacypolicyText from "./PrivacypolicyText";
import { Navbar } from "../Common/Component/Navbar.component";
import { Footer } from "../Common/Component/Footer.component";

const PrivacyPolicy = () => {
  return (
    <>
      <Navbar />
      <Box className={style.wrapper} paddingTop={"90px"}>
        <Box className={style.container}>
          <Heading className={style.primary_Color} as="h1" size="xl">
            Privacy Policy
          </Heading>
          <Box>
          <PrivacypolicyText/>
          </Box>
        </Box>
      </Box>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
